import { render, staticRenderFns } from "./CompletedChip.vue?vue&type=template&id=7dda31aa&scoped=true&"
import script from "./CompletedChip.vue?vue&type=script&lang=js&"
export * from "./CompletedChip.vue?vue&type=script&lang=js&"
import style0 from "./CompletedChip.vue?vue&type=style&index=0&id=7dda31aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dda31aa",
  null
  
)

export default component.exports